export const CLIPBOARD_HEALTH = "Clipboard Health";

export const WORKER_AND_WORKPLACE_DATA_STALE_TIME_IN_MS = 60 * 1000; // 60 seconds
